import { ChatAgentType } from '@constants/chat-agents';
import {
  chatService,
  type AiDisplaySetting,
} from '@services/chatService';

/** Fired after open-bootstrap fetches instruction-manual suggestion. */
export const CHATBOT_INSTRUCTIONS_SYNCED = 'chatbot:instructions-synced';

export type ChatbotOpenRequestResult = {
  aiDisplay: AiDisplaySetting | null;
};

type RunChatbotOpenRequestsParams = {
  activeAgent: ChatAgentType;
  loadCurrentChatSession: (typeChat?: ChatAgentType) => Promise<string | null>;
  /** Welcome / tip bubble — Conversation vẫn refetch theo key. */
  refreshWelcomeSuggestions?: () => void;
};

/**
 * Gom các request khi mở chatbot vào một chỗ để dễ kiểm soát.
 * - GET /sessions/current (+ history)
 * - personalization ai_display
 * - instruction-manual suggestions
 * - (callback) refresh quick-suggestions UI
 */
export async function runChatbotOpenRequests(
  params: RunChatbotOpenRequestsParams,
): Promise<ChatbotOpenRequestResult> {
  const token = sessionStorage.getItem('access_token');
  const { activeAgent, loadCurrentChatSession, refreshWelcomeSuggestions } = params;

  const loadSession = loadCurrentChatSession(activeAgent).catch((error) => {
    console.error('[ChatbotOpen] loadCurrentChatSession failed:', error);
    return null;
  });

  const loadAiDisplay = token
    ? chatService.getOrCreateAiDisplaySetting(token).catch((error) => {
        console.error('[ChatbotOpen] getOrCreateAiDisplaySetting failed:', error);
        return null;
      })
    : Promise.resolve(null);

  const loadInstructions = token
    ? chatService.getInstructionSuggestions(token).catch((error) => {
        console.error('[ChatbotOpen] getInstructionSuggestions failed:', error);
        return null;
      })
    : Promise.resolve(null);

  const [, aiDisplay, instructionsRes] = await Promise.all([
    loadSession,
    loadAiDisplay,
    loadInstructions,
  ]);

  const suggestion =
    (instructionsRes as any)?.data?.suggestion ??
    (instructionsRes as any)?.suggestion ??
    null;

  const instructionItems = Array.isArray(suggestion)
    ? suggestion
    : typeof suggestion === 'string' && suggestion
      ? [suggestion]
      : null;

  if (instructionItems && instructionItems.length > 0) {
    window.dispatchEvent(
      new CustomEvent(CHATBOT_INSTRUCTIONS_SYNCED, { detail: instructionItems }),
    );
  }

  refreshWelcomeSuggestions?.();

  return { aiDisplay };
}
